let language = {
	getLanguage: () => {
		return navigator.language;
	},
	isLanguageRTL: () => {
		let language = navigator.language;

		if (language.indexOf("ar") === 0 || language === "he") return true;
		return false;
	},
	// Overide css to rtl, potentials affected property are shown at the end of file
	setRTLStyle: () => {
		let style = document.createElement("style");
		style.appendChild(document.createTextNode(""));
		document.head.appendChild(style);

		// RTL
		style.sheet.insertRule(".App { direction:rtl; }", 0);
		// BS COLUMN
		style.sheet.insertRule(
			".col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7,  .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12  {float: right;}",
			1
		);
		style.sheet.insertRule(
			".col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7,  .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12  {float: right;}",
			2
		);
		style.sheet.insertRule(
			".col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7,  .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12  {float: right;}",
			3
		);
		style.sheet.insertRule(
			".col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7,  .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12  {float: right;}",
			4
		);
		// FLOATS
		style.sheet.insertRule(
			".float-right  {float: left !important;}",
			5
		);
		style.sheet.insertRule(
			".float-left  {float: right !important;}",
			6
		);
		// TH TEXT ALIGN
		style.sheet.insertRule(
			"th {text-align: right !important;}",
			7
		);
	}
};

export default language;

/* POTENTIAL RTL PROPERTIES **
background
background-position
border
border-radius
clear
cursor
direction
float
left/right
margin
padding
text-align
text-indent
** /POTENTIAL RTL PROPERTIES */


// WEBPACK FOOTER //
// ./src/utils/language.js